import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

import { RtPMPlugin } from '../../editor/types';
import { FocusPlugin } from './focus';

export class PlaceholderPlugin implements RtPMPlugin {
  private plugin = new Plugin({
    props: {
      decorations: state => {
        const doc = state.doc;

        const isDocEmpty =
          doc.childCount === 1 && doc.firstChild?.isTextblock && doc.firstChild!.content.size === 0;

        const pluginState = FocusPlugin.getState(state)!;

        if (isDocEmpty && !pluginState.focused) {
          const placeholderElement = document.createElement('span');
          placeholderElement.className = 'wysiwg-placeholder';
          placeholderElement.textContent = this.text;
          return DecorationSet.create(doc, [Decoration.widget(1, placeholderElement)]);
        }

        return null;
      },
    },
  });

  constructor(private text: string) {}

  public getNativeEditorPlugins() {
    return [this.plugin];
  }
}
